import $ from 'jquery';

const banner = $('.banner');

let desktopBannerHeight = banner.data( 'desktop-height' );
let mobileBannerHeight = banner.data( 'mobile-height' );

$(window).on('resize', () => {
	changeBannerHeight()
})

const changeBannerHeight = () => {
	if ( window.innerWidth >= 640 ) {
		banner.height(desktopBannerHeight);
	} else {
		banner.height(mobileBannerHeight);
	}
}

changeBannerHeight()